(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["native-winecush-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazenne-quantity-offers')) {
    customElements.define('lazenne-quantity-offers', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-quantity]');
          const input = this.quantityInput;
          if (!button || !this.contains(button) || button.disabled || !input) return;
          input.value = button.dataset.quantity;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.updateChoices();
        }, { signal });
        for (const type of ['input', 'change']) {
          document.addEventListener(type, event => {
            if (event.target === this.quantityInput) this.updateChoices();
          }, { signal });
        }
        requestAnimationFrame(() => { this.hidden = !this.quantityInput; this.updateChoices(); });
      }
      disconnectedCallback() { this.abortController?.abort(); }
      get quantityInput() {
        return document.getElementById(this.dataset.formId)?.elements.namedItem('quantity');
      }
      updateChoices() {
        const input = this.quantityInput;
        if (!input) return;
        const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
        for (const button of this.querySelectorAll('button[data-quantity]')) {
          const quantity = Number(button.dataset.quantity);
          button.disabled = quantity < min || quantity > max || (quantity - min) % step !== 0;
          button.setAttribute('aria-pressed', String(quantity === Number(input.value)));
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    let refreshTimer;
    let labelFrame;
    const started = new WeakSet();
    const renderedSelector = '.yotpo-sr-star-full, .yotpo-sr-star-half';
    const schedule = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => {
        const pending = [...document.querySelectorAll('.product-card__yotpo-rating')].filter(card => !started.has(card));
        if (!pending.length) return;
        pending.forEach(card => started.add(card));
        const deadline = Date.now() + 20000;
        const initialize = () => {
          if (!pending.some(card => card.isConnected)) return;
          const container = window.yotpoWidgetsContainer;
          if (typeof container?.initWidgets !== 'function') {
            if (Date.now() < deadline) window.setTimeout(initialize, 250);
            return;
          }
          container.initWidgets();
          window.setTimeout(() => {
            let replaced = false;
            pending.forEach(card => {
              if (!card.isConnected || card.querySelector(renderedSelector)) return;
              const previous = card.querySelector('.yotpo-widget-instance');
              if (!previous) return;
              const fresh = document.createElement('div');
              fresh.className = 'yotpo-widget-instance';
              ['data-yotpo-instance-id', 'data-yotpo-product-id', 'data-yotpo-section-id'].forEach(name => {
                const value = previous.getAttribute(name);
                if (value !== null) fresh.setAttribute(name, value);
              });
              card.dataset.reviewRecovery = 'attempted';
              previous.replaceWith(fresh);
              replaced = true;
            });
            if (replaced) container.initWidgets();
          }, 6500);
        };
        initialize();
      }, 100);
    };
    const observeCards = () => {
      const main = document.querySelector('main') || document.getElementById('main');
      if (!main) return;
      new MutationObserver(mutations => {
        window.cancelAnimationFrame(labelFrame);
        labelFrame = window.requestAnimationFrame(() => {
          main.querySelectorAll('.product-card__yotpo-rating[data-review-singular]').forEach(card => {
            const label = card.querySelector('.yotpo-sr-bottom-line-text');
            const desired = card.dataset.reviewSingular;
            if (label && /^1\s+\D/.test(label.textContent.trim()) && label.textContent.trim() !== desired) {
              label.textContent = desired;
            }
          });
        });
        const addedCards = mutations.some(({ addedNodes }) => [...addedNodes].some(node =>
          node instanceof Element && (node.matches('.product-card__yotpo-rating') || node.querySelector('.product-card__yotpo-rating'))
        ));
        if (addedCards) schedule();
      }).observe(main, { childList: true, subtree: true });
      schedule();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards, { once: true });
    } else {
      observeCards();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
